import { ShieldCheck } from "lucide-react";
import { CHIP_COLORS } from "../utils/restrictedChip";

// Shield + days-clean number on a restricted habit's card (see restrictedChip.js).
// No words on purpose (Jade); the Habits tab's one-time guide explains it.
export function ShieldChip({ days, tone = "clean", onClick, title, tour }) {
  const c = CHIP_COLORS[tone] || CHIP_COLORS.clean;
  return (
    <button type="button" onClick={onClick} title={title} aria-label={title} data-tour={tour}
      style={{
        flexShrink: 0, height: 28, minHeight: 0, minWidth: 0, padding: "0 10px 0 8px", borderRadius: 99,
        border: "none", background: c.bg, color: c.ink, display: "flex", alignItems: "center", gap: 4,
        fontFamily: "inherit", fontSize: 12.5, fontWeight: 800, cursor: "pointer", touchAction: "manipulation",
        transition: "background 0.2s, color 0.2s",
      }}>
      <ShieldCheck size={15} color={c.ink} strokeWidth={2.4} />
      <span>{days}</span>
    </button>
  );
}
